import { useMemo } from 'react';

import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';
import { formatPhone } from 'reservations/base/helpers/phone';
import {
  getFullName,
  getNumberOfGuests
} from 'reservations/booking/helpers/index';
import { useBookingDetails } from 'reservations/booking/providers/BookingProvider';
import { useIsWaitlist } from 'reservations/booking/providers/BookingProvider';
import { getFormattedPositionInLine } from 'reservations/waitlist/helpers/getFormattedPositionInLine';

export const useFormattedBookingDetails = () => {
  const {
    firstName,
    lastName,
    partySize,
    dateAndTime,
    phone,
    positionInQueue,
    ...otherDetails
  } = useBookingDetails();
  const isWaitlist = useIsWaitlist();
  const fullName = getFullName(firstName, lastName);
  const formattedPhone = formatPhone(phone);
  const numberOfGuests = getNumberOfGuests(partySize);
  const formattedDateAndTime = useMemo(
    () =>
      isWaitlist
        ? COMMON_DATETIME_FORMATS.dayDateOnly(new Date(dateAndTime))
        : COMMON_DATETIME_FORMATS.dayDateAndTime(new Date(dateAndTime)),
    [dateAndTime, isWaitlist]
  );
  const queueOrdinal = getFormattedPositionInLine(positionInQueue - 1);
  const formattedPositionInLine = `${queueOrdinal} in line`;

  return {
    fullName,
    numberOfGuests,
    formattedDateAndTime,
    formattedPhone,
    formattedPositionInLine,
    ...otherDetails
  };
};
